import React from "react";
import { Search, Grid, List, ChevronDown } from "lucide-react";

const ControlsBar = ({
  search,
  setSearch,
  viewMode,
  setViewMode,
  selectedCategory,
  setSelectedCategory,
  showCategoryFilter,
  setShowCategoryFilter,
  allCategories,
  getCategoryColor,
  getCategoryName,
  menuItems,
  categoryStats,
}) => (
  <div className="flex flex-col lg:flex-row gap-4 lg:items-center justify-between bg-white rounded-xl shadow-sm border border-gray-200 p-4">
    {/* Search */}
    <div className="flex-1 max-w-md">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search menu items..."
          className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all"
        />
      </div>
    </div>
    {/* View Mode & Category Filter */}
    <div className="flex items-center gap-3">
      <div className="flex items-center bg-gray-100 rounded-lg p-1">
        <button
          onClick={() => setViewMode("grid")}
          className={`p-2 rounded-md transition-all ${
            viewMode === "grid"
              ? "bg-white shadow-sm text-emerald-600"
              : "text-gray-600 hover:text-gray-800"
          }`}
        >
          <Grid className="w-4 h-4" />
        </button>
        <button
          onClick={() => setViewMode("list")}
          className={`p-2 rounded-md transition-all ${
            viewMode === "list"
              ? "bg-white shadow-sm text-emerald-600"
              : "text-gray-600 hover:text-gray-800"
          }`}
        >
          <List className="w-4 h-4" />
        </button>
      </div>
      {/* Category Dropdown */}
      <div className="relative category-filter-container">
        <button
          onClick={() => setShowCategoryFilter(!showCategoryFilter)}
          className="px-4 py-2.5 bg-white border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-all flex items-center gap-2 min-w-[140px] justify-between"
        >
          <div className="flex items-center gap-2">
            {selectedCategory !== "all" && (
              <div
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: getCategoryColor(selectedCategory) }}
              />
            )}
            <span className="truncate">
              {selectedCategory === "all"
                ? "All Categories"
                : getCategoryName(selectedCategory)}
            </span>
          </div>
          <ChevronDown className="w-4 h-4 flex-shrink-0" />
        </button>
        {showCategoryFilter && (
          <div className="absolute top-full right-0 mt-1 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-50 max-h-80 overflow-y-auto">
            <div className="p-2">
              <button
                onClick={() => {
                  setSelectedCategory("all");
                  setShowCategoryFilter(false);
                }}
                className={`w-full text-left px-3 py-2.5 rounded-md transition-all flex items-center gap-3 ${
                  selectedCategory === "all"
                    ? "bg-emerald-50 text-emerald-700 font-medium"
                    : "hover:bg-gray-50"
                }`}
              >
                <div className="w-3 h-3 rounded-full bg-gray-400" />
                <span>All Categories</span>
                <span className="ml-auto text-sm text-gray-500">
                  ({menuItems.length})
                </span>
              </button>
              {allCategories
                .sort(
                  (a, b) =>
                    (categoryStats[b.id] || 0) - (categoryStats[a.id] || 0)
                )
                .map((category) => (
                  <button
                    key={category.id}
                    onClick={() => {
                      setSelectedCategory(category.id);
                      setShowCategoryFilter(false);
                    }}
                    className={`w-full text-left px-3 py-2.5 rounded-md transition-all flex items-center gap-3 ${
                      selectedCategory === category.id
                        ? "bg-emerald-50 text-emerald-700 font-medium"
                        : "hover:bg-gray-50"
                    }`}
                  >
                    <div
                      className="w-3 h-3 rounded-full"
                      style={{ backgroundColor: category.color }}
                    />
                    <span className="truncate">{category.name}</span>
                    <span className="ml-auto text-sm text-gray-500">
                      ({categoryStats[category.id] || 0})
                    </span>
                  </button>
                ))}
            </div>
          </div>
        )}
      </div>
    </div>
  </div>
);

export default ControlsBar;
